
const key_user_id: string = 'userId';
const key_subject_id: string = 'subjectId';
export const demo_val: string = 'demo';

class User {
    userId: string;
    subjectId: string;
    constructor() {
        let user_id = localStorage.getItem(key_user_id);
        let subject_id = localStorage.getItem(key_subject_id)?.toLowerCase();

        this.userId = user_id ? user_id : demo_val;
        this.subjectId = subject_id ? subject_id : demo_val;
    }

    static fromQR(jsonStr: string): User | null {
        try {
            const json = JSON.parse(jsonStr);
            if (json.userId !== undefined && json.subjectId !== undefined) {
                let user = new User();
                user.userId = json.userId;
                user.subjectId = json.subjectId;
                return user;
            }
        } catch (e) {
            console.error(e);
        }
        return null;
    }
    static fromURL(urlStr: string): User | null {


        try {
            let url = new URL(urlStr);
            let user_id = url.searchParams.get("user_id");
            let subject_id = url.searchParams.get("subject_id");
            if (user_id !== null && subject_id !== null) {
                let user = new User();
                user.userId = user_id;
                user.subjectId = subject_id;
                return user;
            }
        } catch (e) {
            console.error(e);
        }
        return null;
    }

    save(userId: string, subjectId: string): void {
        localStorage.setItem(key_user_id, userId);
        localStorage.setItem(key_subject_id, subjectId);
    }
    singOut(): void {
        localStorage.removeItem(key_user_id);
        localStorage.removeItem(key_subject_id);
    }



    isDemo(): boolean {
        return this.userId === demo_val || this.subjectId === demo_val;
    }
    isSingIn(): boolean {
        return localStorage.getItem(key_user_id) !== null
            && localStorage.getItem(key_subject_id) !== null;
    }
}

export default User;